import { HISTORY_SET } from '../action-types/history.action-types';

export type HistoryReducer = {
  history: Array<string>;
};

const initialState: HistoryReducer = {
  history: [],
};

const historyReducer = (state = initialState, action) => {
  switch (action.type) {
    case HISTORY_SET: {
      return {
        ...state,
        history: action.history,
      };
    }
    default: {
      return state;
    }
  }
};

export default historyReducer;
